import React, { SVGProps } from "react";

export default function SupRefresh(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8659 6.17871C14.6166 4.26486 12.456 3 10 3C6.47353 3 3.55612 5.60771 3.07089 9H0.5L3.5 13L6.5 9H4.08296C4.55904 6.16229 7.027 4 10 4C12.2208 4 14.1599 5.2066 15.1973 7H15.247L15.8659 6.17871ZM2.5 10L3.5 11.3333L4.5 10H2.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 16C12.973 16 15.441 13.8377 15.917 11H13.5L16.5 7L19.5 11H16.9291C16.4439 14.3923 13.5265 17 10 17C7.53958 17 5.37564 15.7306 4.12738 13.811L4.73851 13H4.80269C5.84012 14.7934 7.77915 16 10 16ZM16.5 8.66667L15.5 10H17.5L16.5 8.66667Z"
        fill="currentColor"
      />
    </svg>
  );
}
